import type { OpenerVariant } from './types';

/**
 * Preset names per library variant — mirrors `src/core/variants/<variant>/presets.ts`
 * in pack-opener-js. Kept as a literal so the console never imports the library
 * (and Pixi with it) just to list them. The first entry is the default.
 */
export const VARIANT_PRESETS: Record<OpenerVariant, readonly [string, ...string[]]> = {
  slice: ['classic'],
  burst: ['charged'],
  carousel: ['showcase'],
};

export function presetsFor(variant: OpenerVariant): readonly string[] {
  return VARIANT_PRESETS[variant];
}

export function defaultPresetFor(variant: OpenerVariant): string {
  return VARIANT_PRESETS[variant][0];
}
